import React from 'react';
import { connect } from 'react-redux';
import MailIcon from '../MailIcon';

const ConfirmationUI = ({ user }) => {
  return (
    <React.Fragment>
      <MailIcon />
      <h2 className="my-4 font-weight-bold">Email sent</h2>
      <b>An email has been sent to <span className="inner-link">{user && user.email ? user.email : 'your email'}</span>.
      Please check your spam folder if you can't see the email in your inbox.
      Follow the instructions in the email to reset your password.</b>

    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
})

export default connect(mapStateToProps)(ConfirmationUI);
